/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProfileAnalyticsCumulativeHistogram } from '../../models/profile-analytics-cumulative-histogram';

export interface ProfileUtmCampaignsDateHistogram$Params {
  id: number;
  type: 'campaign' | 'source' | 'medium';

/**
 * Name of simple campaign (e.g. key from API service 'profileUtmCampaignsTypeHistogram')
 */
  typeId: string;
}

export function profileUtmCampaignsDateHistogram(http: HttpClient, rootUrl: string, params: ProfileUtmCampaignsDateHistogram$Params, context?: HttpContext): Observable<StrictHttpResponse<ProfileAnalyticsCumulativeHistogram>> {
  const rb = new RequestBuilder(rootUrl, profileUtmCampaignsDateHistogram.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.path('type', params.type, {});
    rb.query('typeId', params.typeId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ProfileAnalyticsCumulativeHistogram>;
    })
  );
}

profileUtmCampaignsDateHistogram.PATH = '/analytics/profile/{id}/utm-campaigns/{type}/histogram';
